// extracted by mini-css-extract-plugin
export default {"container":"privacy_container__6Hyl-","points":"privacy_points__eMRcY"};